import { render, staticRenderFns } from "./UploadLabUsingAiDialog.vue?vue&type=template&id=8477d830&scoped=true"
import script from "./UploadLabUsingAiDialog.vue?vue&type=script&lang=js"
export * from "./UploadLabUsingAiDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadLabUsingAiDialog.vue?vue&type=style&index=0&id=8477d830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8477d830",
  null
  
)

export default component.exports